// extracted by mini-css-extract-plugin
export default {"image":"Logos_image__zAXJF"};